export default __webpack_public_path__ + "static/media/hellometer_cover_horiz.75b135cb.png";